const url = 'tipo-solicitacao-ativacao-indicador';
class TipoSolicitacaoAtivacaoService {
    async list() {
        const response = await window.$http.get(`${url}/all`);
        return response.data;
    }
}

export default new TipoSolicitacaoAtivacaoService();
